import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class EncryptionDecryptionService {

    public constService!: any;
    envKey: string = import.meta.env.NG_APP_key;
    envIv: string = import.meta.env.NG_APP_iv;
    key: any;
    iv: any;


    Encryption(pass: { toString: () => any; }): string {
        this.key = CryptoJS.enc.Utf8.parse(`${this.envKey}`);
        this.iv = CryptoJS.enc.Utf8.parse(`${this.envIv}`);
        const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(pass.toString()), this.key,
            {
                keySize: 128 / 8,
                iv: this.iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

        return encrypted.toString();
    }

    Decryption(passEnc: any) {
        this.key = CryptoJS.enc.Utf8.parse(`${this.envKey}`);
        this.iv = CryptoJS.enc.Utf8.parse(`${this.envIv}`);
        const decrypted = CryptoJS.AES.decrypt(passEnc, this.key, {
            keySize: 128 / 8,
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        //console.log('Decrypted data:', decrypted);
        return decrypted.toString(CryptoJS.enc.Utf8);

    }


}